<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  <div class="astral-stack-l">
    @if (form) {
      <section class="astral-content-width astral-section-surface">
        <astral-form [form]="form" [columns]="4" (formSubmit)="onSubmit()">
          <astral-select [control]="form.controls['category']" [itemsSource]="categories"></astral-select>
          @if (!isNew) {
            <div class="astral-grid-mobile-full">
              <astral-input
                inputId="contact-form-contact-number"
                label="TENANT.CONTACT_NUMBER"
                [value]="dataContext.number || ''"
                [readonly]="true"
              ></astral-input>
            </div>
          }
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-input [control]="form.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
          @if (idTypeSelection && idType) {
            <astral-layout-group
              [span]="2"
              mobileSpan="full"
              [columns]="2"
              [mobileColumns]="2"
              [columnGap]="'16px'"
              >
              <astral-select [control]="form.controls['idType']" [itemsSource]="idTypeSelection"></astral-select>
              <div class="astral-layout-item">
                <app-contact-id [idType]="idType" [control]="form.controls['contactIdentification']"></app-contact-id>
                @if (existingContactName || hasB2CSuggestion) {
                  <div class="id-feedback">
                    @if (existingContactName) {
                      <div class="contact-form__error">{{ 'TENANT.EXISTING_CONTACT' | translate }}: {{ existingContactName }}</div>
                    }
                    @if (hasB2CSuggestion && !hasB2C) {
                      <div class="b2c-exist">{{ 'TENANT.EXISTS_B2C_MANDATE' | translate }}</div>
                    }
                  </div>
                }
              </div>
            </astral-layout-group>
          } @else {
            @if (idTypeSelection) {
              <astral-select [control]="form.controls['idType']" [itemsSource]="idTypeSelection"></astral-select>
            }
            @if (idType) {
              <div class="astral-grid-mobile-full">
                <app-contact-id [idType]="idType" [control]="form.controls['contactIdentification']"></app-contact-id>
                @if (existingContactName || hasB2CSuggestion) {
                  <div class="id-feedback">
                    @if (existingContactName) {
                      <div class="contact-form__error">{{ 'TENANT.EXISTING_CONTACT' | translate }}: {{ existingContactName }}</div>
                    }
                    @if (hasB2CSuggestion && !hasB2C) {
                      <div class="b2c-exist">{{ 'TENANT.EXISTS_B2C_MANDATE' | translate }}</div>
                    }
                  </div>
                }
              </div>
            }
          }
          @if (isCompany) {
            <astral-input [control]="form.controls['referenceName']"></astral-input>
          }
          @if (isCompany) {
            <astral-input [control]="form.controls['vatNumber']"></astral-input>
          }
          <astral-input
            [control]="form.controls['email']"
            [helpText]="'TENANT.HELP_TEXT.EMAIL'"
            [type]="'email'"
            [inputMode]="'email'"
          ></astral-input>
          <astral-input
            [control]="form.controls['emailInvoicing']"
            [helpText]="'TENANT.HELP_TEXT.EMAIL_INVOICING'"
            [type]="'email'"
            [inputMode]="'email'"
          ></astral-input>
          @if (counterPartUsed) {
            <astral-input [control]="form.controls['counterpart']"></astral-input>
          }
          @if (isCompany) {
            <astral-toggle
              [control]="form.controls['eInvoiceSpecified']"
              [helpText]="'TENANT.HELP_TEXT.EINVOICE_SPECIFIED'"
            ></astral-toggle>
          }
          @if (hasB2B) {
            <astral-input
              [control]="form.controls['eInvoiceAddress']"
              [helpText]="'TENANT.HELP_TEXT.EINVOICE_ADDRESS'"
            ></astral-input>
          }
          <div class="astral-grid-span-2">
            <app-bank-account [dataContext]="dataContext.bankAccount" [form]="form"></app-bank-account>
          </div>
          <astral-toggle [control]="form.controls['noJointDebiting']" [helpText]="'TENANT.HELP_TEXT.NO_JOINT_DEBITING'"></astral-toggle>
          <astral-toggle
            [control]="form.controls['applyCreditOnInvoices']"
            [helpText]="'TENANT.HELP_TEXT.APPLY_CREDIT_ON_INVOICES'"
          ></astral-toggle>
          @if (hasB2C || hasB2CSuggestion) {
            <astral-toggle
              [control]="form.controls['b2cToggleControl']"
              [helpText]="b2cToggleHelpText"
            ></astral-toggle>
          }
          @if (hasB2C || hasB2CSuggestion) {
            <div class="astral-grid-mobile-full">
              <astral-input
                inputId="contact-form-b2c-subscriptions"
                label="TENANT.EINVOICE_ADDRESS_B2C"
                helpText="TENANT.HELP_TEXT.EINVOICE_ADDRESS_B2C"
                [value]="b2CSubscriptionsText || ''"
                [readonly]="true"
              ></astral-input>
            </div>
          }
          <astral-textarea [control]="form.controls['note']" [rows]="5" [span]="'full'"></astral-textarea>
          @if (isNew) {
            <p class="astral-grid-full help-text">{{ 'TENANT.INFORMATION_NEW_CONTACT_ADDRESS' | translate }}</p>
          }
          <div class="astral-grid-full">
            <app-postal-address
              [group]="form.controls['invoiceAddress']"
              [showName]="true"
              [title]="''"
              [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
              [model]="dataContext.invoiceAddress"
            ></app-postal-address>
          </div>
        </astral-form>
      </section>
    }

    @if (dataContext) {
      @if (!dataContext.isNew) {
        <div class="astral-content-width astral-accordion-stack">
          @if (dataContext.hasLeaseAgreements) {
            <astral-accordion
              class="astral-grid-full"
              [header]="'LEASE_AGREEMENT.LIST_HEADER'"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.LEASE_AGREEMENT_LIST_CONTACT'"
              [allowWidthExpansion]="true">
              <div class="contact-form__accordion-content">
                <app-list-view
                  [columnDefinition]="leaseAgreementColumnDefinition"
                  [itemsSource]="dataContext.leaseAgreements"
                  [preferencesKey]="'contact.lease-agreements'"
                  (rowClick)="onRowClicked($event)"
                ></app-list-view>
              </div>
            </astral-accordion>
          }
          <astral-accordion
            class="astral-grid-full"
            [helpText]="'TENANT.HELP_TEXT.FAULT_NOTIFICATION_LIST'"
            [header]="'FAULT_NOTIFICATION.LIST_HEADER'"
            (stateChanged)="setFaultNotificationsVisibility($event)"
            [allowWidthExpansion]="true">
            <div class="contact-form__accordion-content">
              <app-list-view
                [columnDefinition]="faultNotificationsColumnDefinition"
                [itemsSource]="dataContext.faultNotifications"
                [preferencesKey]="'contact.fault-notifications'"
                (rowClick)="onFaultNotificationRowClicked($event)"
              ></app-list-view>
            </div>
          </astral-accordion>
          @if (dataContext.hasDirectDebitConsents) {
            <astral-accordion
              class="astral-grid-full"
              [header]="'DIRECT_DEBIT.CONSENTS'"
              [helpText]="'DIRECT_DEBIT.HEADER_TOOLTIP_CONSENTS'"
              [allowWidthExpansion]="true">
              <div class="contact-form__accordion-content">
                <app-list-view
                  [columnDefinition]="contactPaymentInformationPerCompanyColumnDefinition"
                  [itemsSource]="dataContext.contactPaymentInformationPerCompanies"
                  [preferencesKey]="'contact.direct-debit-consents'"
                ></app-list-view>
              </div>
            </astral-accordion>
          }
          @if (dataContext.hasContactBalanceTransactions) {
            <astral-accordion class="astral-grid-full" [header]="'COMMON.CREDIT_BALANCE'" [allowWidthExpansion]="true">
              <div class="contact-form__accordion-content">
                <app-list-view
                  [columnDefinition]="contactBalanceTransactionColumnDefinition"
                  [itemsSource]="dataContext.contactBalanceTransactions"
                  [preferencesKey]="'contact.credit-balance-transactions'"
                ></app-list-view>
              </div>
            </astral-accordion>
          }
          @if (dataContext.hasRentApplications) {
            <astral-accordion class="astral-grid-full" [header]="'RENT_APPLICATION.INTERESTED_IN'" [allowWidthExpansion]="true">
              <div class="contact-form__accordion-content">
                <app-list-view
                  [columnDefinition]="rentApplicationsColumnDefinition"
                  [itemsSource]="dataContext.rentApplications"
                  [preferencesKey]="'contact.rent-applications'"
                  (rowClick)="onApplicationRowClicked($event)"
                ></app-list-view>
              </div>
            </astral-accordion>
          }
          <astral-accordion class="astral-grid-full" [header]="'TENANT.USER_ACCOUNT'">
            <div class="contact-form__accordion-content contact-form__accordion-content--stack">
              @if (webUserExists) {
                <app-information-block [text]="'USER.HELP_TEXT.HAVE_ACCOUNT' | translate"></app-information-block>
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                  <astral-input [control]="form.controls['webUserUserName']" [type]="'email'" [inputMode]="'email'"></astral-input>
                  <astral-input [control]="form.controls['webUserCreated']"></astral-input>
                  <astral-input [control]="form.controls['webUserLastLogin']"></astral-input>
                </astral-layout-group>
              } @else {
                <div class="contact-form__account-empty">
                  <app-information-block [text]="'USER.HELP_TEXT.MISSING_ACCOUNT' | translate"></app-information-block>
                  <astral-button variant="secondary" type="button" [label]="dataContext.registrationKey" (click)="onCopyToClipboard()">
                    <img astralButtonIcon src="assets/icons/copy-to-clipboard-icon.png" alt="copy to clipboard" />
                  </astral-button>
                </div>
              }
            </div>
          </astral-accordion>
          @if (dataContext.hasB2CSubscriptions) {
            <astral-accordion class="astral-grid-full" [header]="'B2C_SUBS.EVENTS'" [allowWidthExpansion]="true">
              <div class="contact-form__accordion-content">
                <app-list-view
                  [columnDefinition]="b2CSubscriptionContactColumnDefinition"
                  [itemsSource]="dataContext.b2CSubscriptionContactInformations"
                  [preferencesKey]="'contact.b2c-subscriptions'"
                ></app-list-view>
              </div>
            </astral-accordion>
          }
          <astral-accordion class="astral-grid-full" [helpText]="'TENANT.HELP_TEXT.DOCUMENT_LIST'" [header]="'DOCUMENT.LIST_HEADER'" (stateChanged)="setDocumentsVisibility($event)" [allowWidthExpansion]="true">
            <div class="contact-form__accordion-content contact-form__accordion-content--stack">
              @if (allowLinkContactDocument) {
                <div class="contact-form__document-action">
                  <astral-button variant="primary" size="small" type="button" labelKey="ADD_WITH_DLG_BTN" icon="plus" (click)="linkDocument()"></astral-button>
                </div>
              }
              <app-list-view
                [columnDefinition]="documentsColumnDefinition"
                [itemsSource]="dataContext.documents"
                [contextMenuDefinition]="documentsContextMenuDefinitions"
                [preferencesKey]="'contact.documents'"
              ></app-list-view>
            </div>
          </astral-accordion>
          <astral-accordion class="astral-grid-full" [header]="'LOG.HEADER'" (stateChanged)="allowSectionInit('logs')" [allowWidthExpansion]="true">
            @if (isSectionAllowed('logs')) {
              <div class="contact-form__accordion-content wrap-rows">
                <app-list-view [columnDefinition]="logColumnDefinition" [itemsSource]="logs" [preferencesKey]="'contact.logs'"></app-list-view>
              </div>
            }
          </astral-accordion>
        </div>
      }
    }
  </div>
</section>
